import React from "react";
import ZoomInZoomOut from "../Zoom";

const Canvas = () => {
  return (
    <div>
      <canvas id="canvas"></canvas>
      <ZoomInZoomOut/>
    </div>
  );
};

export default Canvas;
